
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { MapPin, CheckCircle } from 'lucide-react';

const LocalServicesSection = () => {
  const locations = [
    {
      name: "Raleigh, NC",
      county: "Wake County",
      features: [
        "ENERGY STAR® shingles like CertainTeed Landmark Solaris®",
        "HOA-compliant installs for new developments",
        "Solar prep and integrated attic ventilation upgrades",
        "Code-compliant with City of Raleigh Building Safety"
      ]
    },
    {
      name: "Wilson, NC",
      county: "Tornado Corridor",
      features: [
        "Impact-resistant shingles (UL 2218 Class 4) from Owens Corning Duration Storm®",
        "Emergency repair and temporary stabilization",
        "County-permitted replacement services",
        "Wilson Planning & Inspections coordination"
      ]
    },
    {
      name: "Rocky Mount, NC",
      county: "Nash & Edgecombe Counties",
      features: [
        "Storm-ready roof replacement using IKO ArmourZone® systems",
        "Algae-resistant shingle systems for older homes",
        "Priority warranty and storm response coordination",
        "NOAA damage data integration"
      ]
    },
    {
      name: "Greenville, NC",
      county: "Coastal Transition Zone",
      features: [
        "FORTIFIED Roof™ options for hurricane resistance",
        "Heat-reflective coatings from Ames Coatings",
        "Moisture management and thermal cycling stress reduction",
        "Pitt County building code compliance"
      ]
    },
    {
      name: "New Bern, NC",
      county: "Hurricane Zone",
      features: [
        "Ice & water shield installation for flood-prone areas",
        "GAF LayerLock™ systems for extreme wind performance",
        "Craven County Permitting coordination",
        "Hurricane, hailstorm, and insurance surge preparation"
      ]
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl font-bold mb-4">📍 Local Roofing Services by Region</h2>
          <p className="text-gray-600">
            We customize solutions based on your climate, code zone, and property type
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {locations.map((location, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="flex items-center">
                  <MapPin className="h-6 w-6 text-primary mr-3" />
                  <div>
                    <CardTitle className="text-xl">{location.name}</CardTitle>
                    <p className="text-sm text-gray-600">{location.county}</p>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {location.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start">
                      <CheckCircle className="h-4 w-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                      <span className="text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocalServicesSection;
